import type { EventModuleKey } from './eventModules.js';

export const EVENT_PHASES = ['before', 'during', 'after'] as const;
export type EventPhase = (typeof EVENT_PHASES)[number];

export const HOME_BLOCK_KEYS = [
  'event_hero',
  'quick_actions',
  'announcements',
  'happening_now',
  'up_next',
  'featured_speakers',
  'featured_papers',
  'featured_exhibitors',
  'recap',
] as const;

export type HomeBlockKey = (typeof HOME_BLOCK_KEYS)[number];

export interface HomeBlockOverride {
  enabled?: boolean | null;
  title?: string | null;
  order?: number | null;
  visibility?: EventPhase[] | null;
  module_keys?: string[] | null;
  limit?: number | null;
}

/** Sparse event-owned presentation overrides. An empty object preserves the legacy home page. */
export interface EventHomeLayout {
  version?: 1;
  blocks?: Record<string, HomeBlockOverride>;
  custom_sections?: CustomHomeSection[];
}

export type CustomHomeAction =
  | { kind: 'internal_module'; label: string; module_key: EventModuleKey }
  | { kind: 'external_url'; label: string; url: string };

export type CustomHomeSectionContentStyle = 'formatted_text' | 'featured_sponsors';

export interface CustomHomeSection {
  id: string;
  title: string;
  body_markdown: string;
  enabled: boolean;
  order: number;
  visibility: EventPhase[];
  image_url?: string | null;
  image_alt?: string | null;
  action?: CustomHomeAction | null;
  content_style?: CustomHomeSectionContentStyle;
}

export interface ResolvedCustomHomeSection extends Omit<CustomHomeSection, 'action'> {
  action: CustomHomeAction | null;
}

export interface ResolvedHomeBlock {
  key: HomeBlockKey;
  enabled: true;
  title: string;
  order: number;
  visibility: EventPhase[];
  module_keys: EventModuleKey[];
  limit: number;
}
